import React from 'react'
import {
  CheckCircle as ValidateIcon,
  Build as ToolsIcon,
  Assessment as ReportIcon,
} from '@mui/icons-material'
import AdminLandingPage, {
  type AdminLandingCard,
} from '../../../../components/admin/AdminLandingPage'

const cards: AdminLandingCard[] = [
  {
    icon: ValidateIcon,
    title: 'Validate Sync Data',
    description:
      'Compare live API data against database records to validate sync accuracy across Lightspeed, Xero, and Skimmer.',
    to: '/admin/data-sync/tools/validate',
    buttonLabel: 'Start Validation',
  },
  {
    icon: ReportIcon,
    title: 'Sync Health Reports',
    description:
      'Generate comprehensive reports on sync health, performance metrics, and historical trends across all franchise partners.',
    buttonLabel: 'Coming Soon',
    disabled: true,
  },
  {
    icon: ToolsIcon,
    title: 'Sync Troubleshooter',
    description:
      'Interactive troubleshooting tool to diagnose and resolve common sync issues. Guided workflows for fixing connection problems and data inconsistencies.',
    buttonLabel: 'Coming Soon',
    disabled: true,
  },
]

const SyncToolsDashboard: React.FC = () => (
  <AdminLandingPage
    pageKey="dataSync"
    titleOverride="Sync Tools"
    descriptionOverride="Tools for managing and validating sync operations across all systems"
    breadcrumbs={[
      { label: 'Admin', to: '/admin' },
      { label: 'Data Sync', to: '/admin/data-sync/active' },
      { label: 'Sync Tools' },
    ]}
    alert={{
      severity: 'info',
      content:
        'These tools provide advanced functionality for managing sync operations. Use them to validate data consistency, troubleshoot sync issues, and maintain system health.',
    }}
    cards={cards}
  />
)

export default SyncToolsDashboard
